import { Link } from 'react-router-dom';

import {
  Page,
  TableContainer,
  Button,
  TableHeader,
  SearchForm,
  AddIcon,
} from '@occc-app/design-system';
import { useIsUserPermittedTo } from '@occc/utils-access-control';
import { Feature } from '@occc/utils-access-control';
import { useChainId } from '@occc-app/Chain/hooks';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';

import { SegmentListTable } from './segment-list.table';

import { routeCreator } from '../../segments.router';
import { useGetSegments } from '../../hooks/use-get-segments.hook';

const PAGE_TITLE = 'Segments';

export const SegmentListPage = () => {
  const chainId = useChainId();

  const [paginationInfo, onPageChange] = usePaginationParams();
  const [search, setSearch] = useSearchParams();

  const isUserPermittedToCreateSegment = useIsUserPermittedTo(Feature.SEGMENT_CREATE);
  const isUserPermittedToDeleteSegment = useIsUserPermittedTo(Feature.SEGMENT_DELETE);

  const { loading, error, data, paginationProps } = useGetSegments({
    filter: {
      search,
      isDeleted: false,
      chainIdEquals: chainId,
    },
    paginationInfo,
    onPageChange,
  });

  const actions = isUserPermittedToCreateSegment ? (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      startIcon={<AddIcon />}
      to={routeCreator.create()}
      role='button'
    >
      create new segment
    </Button>
  ) : null;

  return (
    <Page browserTabTitle={PAGE_TITLE} actions={actions} pageHeaderProps={{ title: PAGE_TITLE }}>
      <TableContainer>
        <TableHeader
          title={PAGE_TITLE}
          actions={
            <SearchForm onSubmit={({ search }) => setSearch(search)} initialValues={{ search }} />
          }
        />

        <SegmentListTable
          segments={data}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
          isDeleteAllowed={isUserPermittedToDeleteSegment}
        />
      </TableContainer>
    </Page>
  );
};
